module.exports = __webpack_public_path__ + "img/facebook-grey.06fa57f8.svg";